module.exports = __webpack_public_path__ + "static/image/font/pc/bmhanna11yrs-4@3x.jpg?386aee55";